import { render, staticRenderFns } from "./ServiceForm.vue?vue&type=template&id=13df2304"
import script from "./ServiceForm.vue?vue&type=script&lang=js"
export * from "./ServiceForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceForm.vue?vue&type=style&index=0&id=13df2304&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports